import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';

import API from '../../constants/api';
import { PAGE, SIZE } from '../../constants/constants';
import {
    apiCatchBlockFunction,
    getJsonPath,
    isArrayValidAndNotEmpty,
} from '../../constants/CommonUtil';
import MaterialTable from '../MaterialTableV2/MaterialTable';
import DialogComponent from '../DialogComponent/DialogComponent';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { hideSpinner, showSpinner } from '../../redux/modules/spinner/spinner';

class PreviousPurchaseInvoiceLineBatchDetailsDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            batchSchema: null,
            data: [],
            page: PAGE,
            size: SIZE,
            totalElements: 0,
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;

        axios.get(getJsonPath('/PreviousPurchaseInvoiceLines/PreviousPurchaseInvoiceLineBatchesSchema.json'))
            .then((response) => {
                this.setState({ batchSchema: response.data });
            })
            .catch((error) => {
                apiCatchBlockFunction(error, dispatch);
            });

        this.fetchBatchDetails(PAGE, SIZE);
    }


    onPageChange = (page, size) => {
        this.fetchBatchDetails(page, size);
    };

    fetchBatchDetails = async (page, size) => {
        const { dispatch, invoiceLineUuid } = this.props;

        if (!invoiceLineUuid) return;

        try {
            dispatch(showSpinner());
            const response = await axios.get(
                `${API.ACCOUNT_INVOICE.PREVIOUS_PURCHASE_INVOICE_LINES}/${invoiceLineUuid}/batchDetails`,
                { params: { page, size } },
            );

            this.setState({
                data: response.data.content || [],
                totalElements: response.data.totalElements || 0,
                page,
                size,
            });
        } catch (e) {
            apiCatchBlockFunction(e, dispatch);
        } finally {
            dispatch(hideSpinner());
        }
    };

    render() {
        const { onClose } = this.props;
        const {
            batchSchema,
            data,
            page,
            size,
            totalElements,
        } = this.state;

        return (
            <DialogComponent
                open
                handleClose={onClose}
                maxWidth="md"
                header="Previous Purchase Details"
            >
                <Grid container>
                    {
                        isObjectValidAndNotEmpty(batchSchema) && (
                            <Grid item sm={12} lg={12} md={12}>
                                {
                                    isArrayValidAndNotEmpty(data) ? (
                                        <MaterialTable
                                            schema={batchSchema}
                                            uniqueKey="id"
                                            totalElements={totalElements}
                                            page={page}
                                            size={size}
                                            data={data}
                                            onPageChange={this.onPageChange}
                                        />
                                    ) : (
                                        <div
                                            className="flexChildren justify-content-center"
                                            style={{ fontSize: '1.5rem', fontWeight: 300, padding: '1rem' }}
                                        >
                                            No batch details found
                                        </div>
                                    )
                                }
                            </Grid>
                        )
                    }
                </Grid>
            </DialogComponent>
        );
    }
}

PreviousPurchaseInvoiceLineBatchDetailsDialog.propTypes = {
    dispatch: PropTypes.func,
    invoiceLineUuid: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

PreviousPurchaseInvoiceLineBatchDetailsDialog.defaultProps = {
    dispatch: () => {},
};

export default connect()(PreviousPurchaseInvoiceLineBatchDetailsDialog);
